import { Phone, Mail, Clock, Leaf } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import QuoteForm from "../components/QuoteForm";
import { useSEO } from "../hooks/useSEO";
import { site } from "../data/site";
import { method } from "../data/services";

export default function Devis() {
  useSEO({
    title: "Demander un devis gratuit — Jardinage et espaces verts | Embèk Group",
    description:
      "Demandez votre devis gratuit pour l'entretien de jardin, la taille de haies, la tonte de pelouse ou l'aménagement paysager. Réponse rapide d'Embèk Group.",
  });

  return (
    <>
      <PageHeader
        eyebrow="Devis gratuit"
        title="Demander un devis"
        description="Décrivez-nous votre besoin et recevez une proposition claire et adaptée à votre projet."
      />

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid lg:grid-cols-[1fr_1.35fr] gap-12 items-start">
          <div className="lg:sticky lg:top-28 space-y-4">
            {method.map((m, i) => (
              <Reveal key={m.num} delay={i * 0.07}>
                <div className="flex gap-5 bg-white rounded-2xl border border-forest/10 p-6 shadow-sm" data-testid={`devis-step-${m.num}`}>
                  <span className="font-serif text-4xl font-light text-moss/40 leading-none">{m.num}</span>
                  <div>
                    <h3 className="font-serif text-xl text-forest">{m.title}</h3>
                    <p className="mt-1 text-sm text-coal-muted font-light">{m.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <div className="bg-forest-dark grain rounded-2xl p-7 text-sand mt-6">
                <div className="flex items-center gap-3">
                  <Leaf size={18} className="text-moss" />
                  <h3 className="font-serif text-xl">Une question rapide ?</h3>
                </div>
                <ul className="mt-4 space-y-2.5 text-sm text-sand/75">
                  <li className="flex items-center gap-3">
                    <Phone size={14} className="text-moss shrink-0" />
                    <a href={site.phoneHref} data-testid="devis-phone-link" className="hover:text-sand transition-colors">{site.phone}</a>
                  </li>
                  <li className="flex items-center gap-3">
                    <Mail size={14} className="text-moss shrink-0" />
                    <a href={`mailto:${site.email}`} data-testid="devis-email-link" className="hover:text-sand transition-colors break-all">{site.email}</a>
                  </li>
                  <li className="flex items-center gap-3">
                    <Clock size={14} className="text-moss shrink-0" />
                    <span>{site.horaires[0].jours} : {site.horaires[0].heures}</span>
                  </li>
                </ul>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <QuoteForm />
          </Reveal>
        </div>
      </section>
    </>
  );
}
